import api from "../../../services/api.service"


export const hostawayModule = {
    namespaced: true,
    state: {},
    getters: {
        canReadHostaway(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('hostaway');
        },
        canEditHostaway(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('hostaway');
        },
    },
    mutations: {},
    actions: {
        getData() {
            return new Promise(function (resolve) {

                resolve();

            })
        },

        getAllMessages(actions) {

            return new Promise(function (resolve, reject) {
                api.sendRequest('externalPMS/unseen').then(
                    (ans) => {
                        if (ans["messages"] == null)
                            return reject('Could not get Messages ');

                        resolve(ans);
                    }, (error) => {

                        reject(error.message)
                    })
            })

        },
        getMessagesByReservationId(actions, reservationId) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('externalPMS/id/' + reservationId).then(
                    (ans) => {
                        if (ans["messages"] == null)
                            return reject('Could not get messages ');

                        resolve(ans);
                    }, (error) => {

                        reject(error.message)
                    })
            })
        },
        sendHostawayMessage(actions, newMessage) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('externalPMS/send',null,newMessage).then(
                    (ans) => {
                        if (ans["messages"] == null)
                            return reject('Could not send message ');
                        actions.dispatch('notifications/success',
                            {
                                title: {text: 'Hostaway'},
                                message: {text: '%s sent successfully', arguments: ['Message']}
                            },
                            {root: true});
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: {text: 'Hostaway '},
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        },
        blockCalendarDates(actions,{listingId, request}) {
            let $this = this;
            return new Promise(function (resolve, reject) {
                $this.$api.baseApi().post('externalPMS/blockCalendar/' + listingId,request )
                    .then((response) => {
                        actions.dispatch('notifications/success',
                            {title: {text: 'Dates %s', arguments: ['blocked']}, message: {text: '%s successfully', arguments: ['']}},
                            {root: true});

                        resolve(response.data.objects);
                    }, (error) => {

                        actions.dispatch('notifications/error',
                            {
                                title: 'Blocking dates',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        },
        unblockCalendarDates(actions,{calendarId}) {
            let $this = this;
            return new Promise(function (resolve, reject) {
                $this.$api.baseApi().post('externalPMS/unblockCalendar/' + calendarId )
                    .then((response) => {
                        actions.dispatch('notifications/success',
                            {title: {text: 'Dates %s', arguments: ['unblocked']}, message: {text: '%s successfully', arguments: ['']}},
                            {root: true});

                        resolve(response.data.objects);
                    }, (error) => {

                        actions.dispatch('notifications/error',
                            {
                                title: 'Unblocking dates',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        }

    },
};
